// Redirects to /login if there's no stored session token.
// TODO: replace localStorage token check with real session handling once
// AuthService's login flow is fully wired up server-side.
export function requireAuth() {
  const token = localStorage.getItem("token");
  if (!token && window.location.pathname !== "/login") {
    return false;
  }
  return true;
}
